export default {
  header: 'Download the app and login with this email:',
  getApp: 'Get the app',
  getAppWeb: 'Text me a download link',
  webError:
    'We are having trouble messaging that number. Double check it and try again.',
}
